import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import dayjs from 'dayjs'
import HandleDriverModal from './HandleDriverModal'

export default class DriverRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
    }

    this.editDriver = this.editDriver.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.renderModal = this.renderModal.bind(this)
  }

  editDriver(e) {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  openModal() {}

  renderModal() {}

  render() {
    const { terminals, driver } = this.props

    const driverTerminal = terminals.find((t) => t._id === driver.terminal)
    const lastActive = driver.lastActive || driver.last_active
    return (
      <tr>
        <td>
          <Button className="save-settings-btn" style={{ width: '100px' }} type="submit" onClick={this.editDriver}>
            Hantera
          </Button>{' '}
          {this.state.showModal ? <HandleDriverModal modalIsOpen={this.state.showModal} closeModal={this.closeModal} events={this.props.events} driver={this.props.driver} terminals={terminals} /> : null}
        </td>
        <td>{`${driver.name} ${driver.surname}`.slice(0, 25)}</td>
        <td> {driver.phone}</td>
        {localStorage.userType !== 'c_terminal' && <td> {driverTerminal ? driverTerminal.company.slice(0, 25) : ''}</td>}
        <td style={{ whiteSpace: 'pre-line' }}> {(driver.area || '').replace(/;/g, '\n')}</td>
        <td> {driver.driver_id || driver.aliases}</td>
        <td>{lastActive ? dayjs(lastActive).format('D MMMM, YYYY HH:mm') : ''}</td>
        <td>{driver.lastDeliveryAssigned ? dayjs(driver.lastDeliveryAssigned).format('D MMMM, YYYY HH:mm') : ''}</td>
      </tr>
    )
  }
}
